import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import {
  FieldArrayType,
  FieldArrayTypeConfig,
  FormlyFieldConfig,
  FormlyFieldProps,
  FormlyModule,
} from '@ngx-formly/core';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';

interface RepeatProps extends FormlyFieldProps {
  addText: string;
  removeText: string;
  buttonClass?: string;
  buttonIcon?: string;
  cellClass?: string;
  tableClass?: string;
}

export interface FormlyRepeatFieldConfig
  extends FormlyFieldConfig<RepeatProps> {}

@Component({
  selector: 'kon-repeat-table-type',
  standalone: true,
  imports: [CommonModule, FormlyModule, ButtonModule, TooltipModule],
  template: `
    <div class="mb-3">
      <p *ngIf="props.description">{{ props.description }}</p>
      <table
        *ngIf="field.fieldGroup?.length"
        [class]="props.tableClass ?? 'table-auto w-full '"
      >
        <thead>
          <tr>
            @if (fields()?.length) {
            <th *ngFor="let field of fields()" class="font-normal">
              {{ field.props?.label
              }}{{ field.props?.required ? '&nbsp;*' : '' }}
              <i
                *ngIf="field.props?.description"
                class="pi pi-info-circle text-xs"
                [pTooltip]="field.props?.description"
              ></i>
            </th>
            } @else {
            <th class="font-normal">
              {{ props.label }}{{ props.required ? '&nbsp;*' : '' }}
              <i
                *ngIf="props.description"
                class="pi pi-info-circle text-xs"
                [pTooltip]="props.description"
              ></i>
            </th>
            }

            <th class="w-12"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let rowField of field.fieldGroup; index as $index">
            @if (rowField.fieldGroup) {
            <td
              *ngFor="let colField of rowField.fieldGroup"
              [class]="props.cellClass"
            >
              <formly-field
                [field]="removeLabelAndDescription(colField)"
              ></formly-field>
            </td>
            } @else {
            <td [class]="props.cellClass">
              <formly-field
                [field]="removeLabelAndDescription(rowField)"
              ></formly-field>
            </td>
            }

            <td class="flex items-stretch w-12 pl-1">
              <button
                pButton
                type="button"
                [label]="props.removeText"
                [disabled]="props.disabled"
                (click)="remove($index)"
                icon="pi pi-times"
                class="p-button-danger p-button-text self-start"
              ></button>
            </td>
          </tr>
        </tbody>
      </table>

      <div class="flex items-center">
        <p-button
          [disabled]="props.disabled"
          [label]="props.addText"
          (click)="add()"
          icon="pi pi-plus"
          [class]="props.buttonClass"
          size="small"
        ></p-button>
      </div>
    </div>
  `,
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyRepeatTableTypeComponent extends FieldArrayType<
  FieldArrayTypeConfig<RepeatProps>
> {
  override defaultOptions?:
    | Partial<FieldArrayTypeConfig<RepeatProps>>
    | undefined = {
    props: {
      addText: 'Pridať',
      removeText: '',
    },
  };

  fields = () => (this.field.fieldArray as FormlyFieldConfig).fieldGroup;

  removeLabelAndDescription = (field: FormlyFieldConfig) => {
    if (field.props) {
      field.props.label = undefined;
      field.props.description = undefined;
    }
    return field;
  };
}
